import { render, staticRenderFns } from "./add-invoice.vue?vue&type=template&id=560e8082&scoped=true"
import script from "./add-invoice.vue?vue&type=script&lang=js"
export * from "./add-invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_fa4cvkteopfvx2274rwhhr2idm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560e8082",
  null
  
)

export default component.exports